import { useLazyQuery, useMutation } from '@apollo/client';
import { useAuth } from 'components/custom/authprovider';
import { GET_CUSTOMER_BY_ID } from 'graphql/admin/queries/customers';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import Select from 'react-select';
import { Badge, Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import sendMutationContext from 'utils/sendContext';
import AdminNav from './AdminNav';
import CustomerCard from './components/customer';
import { CREATE_LOCK_NOTE } from 'graphql/admin/mutations/locknotes';
import { SET_ADMINCUSTOMER_PLAID_VERIFY } from 'graphql/admin/mutations/customers';
import { SADropdownOrOther } from 'utils/functions';
import { SAlert } from 'utils/functions';
import { GET_LOCKED_CUSTOMER_PHONE_NUMBERS } from 'graphql/admin/queries/customers';
import { GET_LAST_LOCK_NOTE_BY_CUSTOMER_ID } from 'graphql/admin/queries/locknotes';
import { formatDate } from 'utils/date';
import XTable from './components/table';
import { GET_LOCK_NOTES_BY_CUSTOMER_ID } from 'graphql/admin/queries/locknotes';
import { UPDATE_ADMINCUSTOMER_NOTES } from 'graphql/admin/mutations/customers';
import { SAText } from 'utils/functions';
import { GET_ADMINCUSTOMER_DETAILS } from 'graphql/admin/mutations/customers';
import { SimpleFormatPhone } from 'utils/functions';

function LockNotesLookup() {
  const { wt } = useAuth();
  const { cphone } = useParams("");
  const [inputPhone, setInputPhone] = useState("");
  const history = useHistory();
  const [logoutFlag, setLogoutFlag] = useState(false);

  const location = useLocation();
  const initialPathRef = useRef(location.pathname);
  const basePath = (() => {
    const current = initialPathRef.current;
    const lastSlashIndex = current.lastIndexOf('/');

    if (current.slice(lastSlashIndex, current.length) == "/locknote-lookup") {
      return current + "/";
    }

    return current.slice(0, lastSlashIndex + 1);
  })();

  const [phone, setPhone] = useState("");

  const [customer, setCustomer] = useState(null);
  const [getCustomerById] = useLazyQuery(GET_CUSTOMER_BY_ID, {
    fetchPolicy: "no-cache",
    context: sendMutationContext(wt, setLogoutFlag).context,
    onError: sendMutationContext(wt, setLogoutFlag).onError,
});

  const [customerPhoneData, setCustomerPhoneData] = useState([]);
  const [getLockedCustomerPhoneNumbers] = useLazyQuery(GET_LOCKED_CUSTOMER_PHONE_NUMBERS, {
    fetchPolicy: "no-cache",
    context: sendMutationContext(wt, setLogoutFlag).context,
    onError: sendMutationContext(wt, setLogoutFlag).onError,
  });

  const [lockNotes, setLockNotes] = useState([]);
  const [adminGetLockNotesByCustomerId] = useLazyQuery(GET_LOCK_NOTES_BY_CUSTOMER_ID, sendMutationContext(wt, setLogoutFlag));
  const [adminCustomerLookup] = useMutation(GET_ADMINCUSTOMER_DETAILS, sendMutationContext(wt, setLogoutFlag));

  const [adminCreateLockNote] = useMutation(CREATE_LOCK_NOTE, sendMutationContext(wt, setLogoutFlag));
  const [adminGetLastLockNoteByCustomerId] = useLazyQuery(GET_LAST_LOCK_NOTE_BY_CUSTOMER_ID, sendMutationContext(wt, setLogoutFlag));
  const [adminCustomerSetPlaidVerifyById] = useMutation(SET_ADMINCUSTOMER_PLAID_VERIFY, sendMutationContext(wt, setLogoutFlag));
  const [updateCustomerNotes] = useMutation(UPDATE_ADMINCUSTOMER_NOTES, sendMutationContext(wt, setLogoutFlag));

  const customSelectStyle = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: 'white',
      borderColor: state.isFocused ? 'blue' : 'gray',
      boxShadow: state.isFocused ? '0 0 5px rgba(0, 0, 255, 0.5)' : 'none',
      '&:hover': {
        borderColor: 'blue',
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? 'lightblue'
        : state.isFocused
          ? 'lightblue'
          : 'white',
      color: state.isSelected ? 'white' : 'black',
      '&:hover': {
        backgroundColor: 'lightblue',
      },
    }),
  };

  const updateLockCustomerList = () => {
    getLockedCustomerPhoneNumbers()
      .then((res) => {
        setCustomerPhoneData(() => {
          const customers = (res?.data?.adminGetLockedCustomerPhoneNumbers?.customers ?? [])
            .slice()
            .filter((fCustomer) => {
            // Lazy way of dealing with a re-render issue...
            if (customer && fCustomer.customerid === customer.customerid) {
              return customer.active;
            }

            return true;
          })
            .sort((a, b) => (a.lastname || "").localeCompare((b.lastname || "" )))
            .map((item) => ({
              value: item.customerid,
              label: `${item.phone} - ${item.firstname || ""} ${item.lastname}`
            }));

          return customers;
        });
      });
  };

  const setCustomerPlaidVerify = async (customerId) => {
    const req = await adminCustomerSetPlaidVerifyById({ variables: { id: customerId } });

    if (req && req.data && req.data.adminCustomerSetPlaidVerifyById) {
      const status = req.data.adminCustomerSetPlaidVerifyById.status;

      if (status) {
        if (customer.plaidverified) {
          customer.plaidverified = false;
        } else {
          customer.plaidverified = true;
        }

        setCustomer(customer);
      }
    }
  };

  const lockNote = (customer) => {
    const title = customer.isEnabled ? "Lock" : "Unlock";
    const options = {
      other: "Other",
    };

    SADropdownOrOther(`${title} Note`, "Select the reason for the lock note", "Confirm", options).then((value) => {
      if (value) {
        adminCreateLockNote({
          variables: {
            reason: options[value] ?? value,
            customerid: customer.customerid,
          },
        }).then((res) => {
          const status = res?.data?.createLockNote?.status ?? false;

          if (status) {
            setCustomer((prevCustomer) => {
              return {
                ...prevCustomer,
                active: !prevCustomer.active,
                isEnabled: !prevCustomer.isEnabled,
                locknote: res.data.createLockNote.locknote.reason,
                islock: res.data.createLockNote.locknote.islock,
              };
            });
          } else {
            SAlert("Error", "There was an error creating the lock note. Please try again.", "error");
          }
        }).catch(() => {
          SAlert("Error", "An error occurred while processing the request. Please try again.", "error");
        });
      }
    })
      .finally(() => updateLockCustomerList());
  };

  const listHeader = [
    {
      Header: "Reason",
      accessor: "reason",
      className: "t-cell-3 text-centered mwTable-15",
      disableFilters: true,
      disableSortBy: true,
      notShowSortingDisplay: true,
      Cell: (props) => {
        if (props.value.length > 25) {
          return (
            <div
              style={{
                cursor: "pointer",
              }}
              onClick={() => {
                SAText("Reason", props.value, "success");
              }}
            >
              <span
                style={{
                  display: "inline-block",
                  maxWidth: "25ch",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  verticalAlign: "bottom",
                }}
              >{props.value} </span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-box-arrow-up-right"
                viewBox="0 0 16 16"
              >
                <path fillRule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5" />
                <path fillRule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z" />
              </svg>
            </div>
          );
        }

        return (
          <span>{props.value}</span>
        );
      }
    },
    {
      Header: "Locked",
      accessor: "islock",
      className: "t-cell-3 text-centered mwTable-15",
      disableFilters: true,
      disableSortBy: true,
      notShowSortingDisplay: true,
      Cell: (props) => {
        return (
          <Badge color={!JSON.parse(props.value.toLowerCase()) ? "success" : "danger"} className="status-badge">
            {JSON.parse(props.value.toLowerCase()) ? "Locked" : "Unlocked"}
          </Badge>
        );
      }
    },
    {
      Header: "User",
      accessor: "user.name",
      className: "t-cell-3 text-centered mwTable-15",
      disableFilters: true,
      disableSortBy: true,
      notShowSortingDisplay: true,
      Cell: (props) => {
        return (
          <span>{props.value}</span>
        );
      }
    },
    {
      Header: "DateTime",
      accessor: "datetimecreated",
      className: "t-cell-3 text-centered mwTable-10",
      disableFilters: true,
      disableSortBy: true,
      notShowSortingDisplay: true,
      Cell: (props) =>(
        <span>{formatDate(props.value)}</span>
      )
    },
  ];

  useEffect(() => {
    if (customer && customer.customerid) {
      adminGetLastLockNoteByCustomerId({
        variables: {
          customerid: customer.customerid,
        },
      })
        .then((res) => {
          const status = res?.data?.getLastLockNoteByCustomerId?.status ?? false;

          if (status) {
            customer.locknote = res.data.getLastLockNoteByCustomerId.locknote.reason;
            customer.islock = res.data.getLastLockNoteByCustomerId.locknote.islock;
          }

          setCustomer(customer);
        });

      adminGetLockNotesByCustomerId({
        variables: {
          customerid: customer.customerid,
        },
      })
        .then((res) => {
          const status = res?.data?.getLockNotesByCustomerId?.status ?? false;

          if (status) {
            setLockNotes(res.data.getLockNotesByCustomerId.locknotes.slice().reverse());
          }
        });
    }
  }, [customer?.islock]);

  useEffect(() => {
    if (cphone) {
      setPhone(cphone);
    }

    updateLockCustomerList();
  }, []);

  useEffect(() => {
    if (phone) {
      history.replace({ pathname: basePath + phone });
      return;
    }

    history.replace({ pathname: basePath });
  }, [phone]);

  useEffect(() => {
    if (phone) {
      adminCustomerLookup({
        variables: {
          phone: phone,
        },
      })
        .then((res) => {
          if (res?.data?.adminCustomerLookup?.customer) {
            const data = res.data.adminCustomerLookup.customer;

            adminGetLastLockNoteByCustomerId({
              variables: {
                customerid: data.customerid,
              },
            })
              .then((res) => {
                const status = res?.data?.getLastLockNoteByCustomerId?.status ?? false;
                const customer = {
                  customerid: data.customerid,
                  firstname: data.firstname,
                  lastname: data.lastname,
                  address1: data.address1,
                  address2: data.address2,
                  city: data.city,
                  state: data.state,
                  zip: data.zip,
                  phone: data.phone,
                  email: data.email,
                  country: data.country,
                  gender: data.gender,
                  datetimecreated: data.datetimecreated,
                  datetimeupdated: data.datetimeupdated,
                  birthdate: data.birthdate,
                  active: data.isEnabled,
                  isEnabled: data.isEnabled,
                  plaidverified: data.plaidverified,
                };

                if (status) {
                  customer.locknote = res.data.getLastLockNoteByCustomerId.locknote.reason;
                  customer.islock = res.data.getLastLockNoteByCustomerId.locknote.islock;
                }

                setCustomer(customer);
              });

            adminGetLockNotesByCustomerId({
              variables: {
                customerid: data.customerid,
              },
            })
              .then((res) => {
                const status = res?.data?.getLockNotesByCustomerId?.status ?? false;

                if (status) {
                  setLockNotes(res.data.getLockNotesByCustomerId.locknotes.slice().reverse());
                }
              });
          }
        });
    }
  }, [phone, customerPhoneData]);

  useEffect(() => {
    if (logoutFlag) {
      history.push("/admin/logout");
    }
  }, [logoutFlag]);

  return (
    <div className="admin-wrapper">
      <AdminNav />

      <Container fluid className="content">
        <Row>
          <Col md="12">
            <Card className="card-dark">
              <CardHeader className="card-header-dark">
                <Row>
                  <Col sm="9">
                    Lock Notes Lookup
                  </Col>

                  <Col sm="3" style={{ textAlign: "right" }}>
                    {customerPhoneData &&
                      <Select
                        options={customerPhoneData}
                        inputValue={inputPhone}
                        styles={customSelectStyle}
                        onInputChange={(e) => {
                          if (e.length >= 3 && !isNaN(parseInt(e, 10))) {
                            setInputPhone(SimpleFormatPhone(e));
                            return;
                          }

                          setInputPhone(e);
                        }}
                        onChange={(e) => {
                          getCustomerById({
                            variables: {
                              customerid: e.value,
                            },
                          })
                            .then((res) => {
                              if (res?.data?.adminGetCustomerById?.customer) {
                                const data = res.data.adminGetCustomerById.customer;

                                adminGetLastLockNoteByCustomerId({
                                  variables: {
                                    customerid: data.customerid,
                                  },
                                })
                                  .then((res) => {
                                    const status = res?.data?.getLastLockNoteByCustomerId?.status ?? false;
                                    const customer = {
                                      customerid: data.customerid,
                                      firstname: data.firstname,
                                      lastname: data.lastname,
                                      address1: data.address1,
                                      address2: data.address2,
                                      city: data.city,
                                      state: data.state,
                                      zip: data.zip,
                                      phone: data.phone,
                                      email: data.email,
                                      country: data.country,
                                      gender: data.gender,
                                      datetimecreated: data.datetimecreated,
                                      datetimeupdated: data.datetimeupdated,
                                      birthdate: data.birthdate,
                                      active: data.active,
                                      isEnabled: data.active,
                                      plaidverified: data.plaidverified,
                                    };

                                    if (status) {
                                      customer.locknote = res.data.getLastLockNoteByCustomerId.locknote.reason;
                                      customer.islock = res.data.getLastLockNoteByCustomerId.locknote.islock;
                                    }

                                    setCustomer(customer);

                                    history.replace({ pathname: basePath + customer.phone });
                                  });

                                adminGetLockNotesByCustomerId({
                                  variables: {
                                    customerid: data.customerid,
                                  },
                                })
                                .then((res) => {
                                    const status = res?.data?.getLockNotesByCustomerId?.status ?? false;

                                    if (status) {
                                      setLockNotes(res.data.getLockNotesByCustomerId.locknotes.slice().reverse());
                                    }
                                  });
                              }
                            });
                        }}
                        isSearchable={true}
                        placeholder={`Customer search`}
                      />
                    }
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                {!customer &&
                  <span>No customer found!</span>
                }

                {customer &&
                  <Row>
                    <Col lg="6" md="6" className="customer-card">
                      {customer.plaidverified ?
                        <CustomerCard customer={customer} setCustomer={setCustomer} lockNote={lockNote} updateCustomerNotes={updateCustomerNotes} />
                        :
                        <CustomerCard customer={customer} setCustomer={setCustomer} lockNote={lockNote} setCustomerPlaidVerify={setCustomerPlaidVerify} updateCustomerNotes={updateCustomerNotes} />
                      }
                    </Col>

                    <Col lg="6" md="6" className="customer-card">
                      <h5 className='section-heading'>Lock Notes</h5>
                      <XTable columns={listHeader} loading={false} data={lockNotes} filterbutton={false} />
                    </Col>
                  </Row>
                }
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default LockNotesLookup;